import { useState } from 'react';
import { Container, Row, Col, InputGroup, Form, Button } from "react-bootstrap"
import RagAppsTable from '../../components/Rag/RagAppsTable';
import keyIcon from '../../assets/icon/colorKey.svg';
import { Search } from 'lucide-react';
import filterIcon from '../../assets/img/filterIcons.svg';
import { useNavigate } from 'react-router-dom';
import { groupedData } from '../../components/Rag/grouped-data';
import FilterForm from '../../components/SystemAnalytics/FilterForm';

const getDefaultDateRange = () => {
    const today = new Date();
    const pastDate = new Date();
    pastDate.setDate(today.getDate() - 7);  // 7 days before today
    return { fromDate: pastDate, toDate: today };
};

const ManageRag = () => {
    const navigate = useNavigate();
    const [search, setSearch] = useState("")
    const [show, setShow] = useState(false);
    const [currentchooseApp, setCurrentChoosedApp] = useState<any>("");
    const { fromDate, toDate } = getDefaultDateRange();
    const [dateRange, setDateRange] = useState({
        from: fromDate?.toLocaleDateString("en-GB"),
        to: toDate?.toLocaleDateString("en-GB"),
    });

    // let applicationNames = filterDropdownValues && filterDropdownValues?.filters?.applications?.length > 0 && filterDropdownValues?.filters?.applications?.map((item) => ({ label: item, value: item }))
    let businessGroup = [
        { label: "App-001", value: "21642eee" },
        { label: "SPN-002", value: "SPN-002" },
        { label: "SPN-003", value: "SPN-003" },
        { label: "SPN-004", value: "SPN-004" },
    ];
    let embeddingModel = [
        { label: "App-001", value: "21642eee" },
        { label: "SPN-002", value: "SPN-002" },
        { label: "SPN-003", value: "SPN-003" },
        { label: "SPN-004", value: "SPN-004" },
    ];
    let vectorDatabseProvider = [
        { label: "App-001", value: "21642eee" },
        { label: "SPN-002", value: "SPN-002" },
        { label: "SPN-003", value: "SPN-003" },
        { label: "SPN-004", value: "SPN-004" },
    ];

    return (
        <main>
            <Container fluid className="pt-4">
                <Row className="align-items-center mb-2">
                    <Col>
                        <h5 className="mb-1 rag_header"><span><img src={keyIcon} alt='icon' /></span>Manage All RAG Apps</h5>
                        <div className="rag_subheader">
                            Help new users get started smoothly with guided steps, essential information, and quick access to key features.
                        </div>
                    </Col>
                    <Col xs="12" md="6" lg="5" className="mt-3 mt-md-0">
                        <div className="d-flex gap-2 justify-content-md-end">
                            <div className="search-box d-flex align-items-center">
                                <Search size={18} strokeWidth={1.5} color="#838FB4" />
                                <input
                                    type="text"
                                    placeholder="Search"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                            <Button onClick={() => setShow(true)} variant="outline-secondary" className="d-flex align-items-center gap-2 filterBtn fs-7" style={{ height: '34px', color: "#111111" }}>
                                <img src={filterIcon} alt='filter' />
                                Filter
                            </Button>
                        </div>
                    </Col>
                </Row>

                <RagAppsTable
                    searchTerm={search}
                    initialGroups={groupedData}
                    headers={[
                        { key: "version", label: "Version" },
                        { key: "appName", label: "App-Name", sortable: true },
                        { key: "ragAppName", label: "RAG-App-Name", sortable: true },
                        { key: "status", label: "Status" },
                        { key: "active", label: "Active Status" },
                        { key: "createdAt", label: "Created at", sortable: true },
                        { key: "refreshedAt", label: "Last Data Refreshed at", sortable: true },
                    ]}
                />
                <FilterForm
                    show={show}
                    onClose={() => {
                        setShow(false)
                        // setShowOnlyTimePeriodFilter(false)
                    }}
                    onApply={(filters) => {
                        // fetchData(filters)
                        // setChoosedFilter(filters)
                    }}
                    onDateRangeChange={setDateRange}
                    onCurrentChoosedAppChange={setCurrentChoosedApp}
                    fields={
                        [
                            { key: "timePeriod", label: "Time Period", type: "dateRange" },
                            {
                                key: "businessGroup", label: "Business Group", type: "select", options: businessGroup ? businessGroup : []
                            },
                            {
                                key: "embeddingModel", label: "Embedding Model", type: "select", options: embeddingModel ? embeddingModel : []
                            },
                            {
                                key: "vectorDatabseProvider", label: "Vector Databse Provider", type: "select", options: vectorDatabseProvider ? vectorDatabseProvider : []
                            },
                        ]
                    }
                />
            </Container>
        </main>
    )
}

export default ManageRag